export default __webpack_public_path__ + "static/media/logo.0728d731.svg";